
import Vue from 'vue';
import { EventBus, TypeEventBus } from '../../utils';

export default Vue.extend({
  data() {
    return {
      visible: false,
      message: '',
      color: 'success',
      timeout: 4000,
      showClose: true,
    };
  },
  created() {
    EventBus.$on(TypeEventBus.SNACKBAR, this.showSnackbar);
  },
  methods: {
    showSnackbar({
      message,
      color = 'success',
      timeout = 4000,
      showClose = true,
    }: {
      message: string;
      color?: string;
      timeout?: number;
      showClose?: boolean;
    }) {
      this.message = message;
      this.color = color;
      this.timeout = timeout;
      this.showClose = showClose;
      this.visible = true;
    },
  },
});
